import React from 'react';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { RemoveCircleOutline, ArrowUpward, ArrowDownward } from '@mui/icons-material';

interface QuestionActionButtonsProps {
    onMoveUp?: () => void;
    onMoveDown?: () => void;
    onDelete: () => void;
    isFirst?: boolean;
    isLast?: boolean;
}

/**
 * Action buttons for a question (delete, move down and up).
 */
const QuestionActionButtons: React.FC<QuestionActionButtonsProps> = ({ onMoveUp, onMoveDown, onDelete, isFirst, isLast }) => {
    const theme = useTheme();
    const iconButtonStyles = {
        p: 0.5,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    };

    return (
        <Box sx={{ display: 'flex', gap: 0.25 }}>
            <Tooltip title="Delete question" arrow>
                <Box component="span">
                    <IconButton
                        size="small"
                        onClick={onDelete}
                        aria-label="Delete question"
                        sx={{
                            ...iconButtonStyles,
                        }}
                    >
                        <RemoveCircleOutline fontSize="small" />
                    </IconButton>
                </Box>
            </Tooltip>
            {onMoveDown && !isLast && (
                <Tooltip title="Move question down" arrow>
                    <Box component="span">
                        <IconButton
                            size="small"
                            onClick={onMoveDown}
                            aria-label="Move question down"
                            sx={{
                                ...iconButtonStyles,
                            }}
                        >
                            <ArrowDownward fontSize="small" />
                        </IconButton>
                    </Box>
                </Tooltip>
            )}
            {onMoveUp && !isFirst && (
                <Tooltip title="Move question up" arrow>
                    <Box component="span">
                        <IconButton
                            size="small"
                            onClick={onMoveUp}
                            aria-label="Move question up"
                            sx={{
                                ...iconButtonStyles,
                            }}
                        >
                            <ArrowUpward fontSize="small" />
                        </IconButton>
                    </Box>
                </Tooltip>
            )}
        </Box>
    );
};

export default QuestionActionButtons;
